export default {
    green: '#43b02a',
    yellow: '#ffbc3c',
    orange: '#FF7834',
    darkGray: '#363330',
    mediumGray: '#929292',
    cardGray: '#f8f8f8',
    lightGray: '#f2f2f2',
    red: '#ff5252',
}